import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconShareMessengerStyle0 = gravityIconIndividualCss;

const GravityIconShareMessenger = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e27118a6bd54f733fe6da30584895ce82cf0d18d', color: this.color, size: this.size }, h("svg", { key: '7d08a90e10da8dc479b8d7c63ec3f57672610f39', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '636a31b70aff3294db3db60e846e7641ee4514df', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M10.908 2.004A8.638 8.638 0 0 0 2 10.34a8.154 8.154 0 0 0 3.284 6.478V20l3.048-1.687c.831.231 1.69.349 2.553.349a8.627 8.627 0 0 0 8.908-8.323 8.638 8.638 0 0 0-8.885-8.335Zm.933 11.169-2.25-2.396-4.487 2.475 4.87-5.163 2.25 2.396 4.442-2.452-4.825 5.14Z", fill: "currentColor" }))));
    }
};
GravityIconShareMessenger.style = GravityIconShareMessengerStyle0;

export { GravityIconShareMessenger as gravity_icon_share_messenger };

//# sourceMappingURL=gravity-icon-share-messenger.entry.js.map